/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetDomainSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetDomainRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetDomainSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetDomainSecurity$outboundSchema: z.ZodMiniType<
  GetDomainSecurity$Outbound,
  GetDomainSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getDomainSecurityToJSON(
  getDomainSecurity: GetDomainSecurity,
): string {
  return JSON.stringify(
    GetDomainSecurity$outboundSchema.parse(getDomainSecurity),
  );
}

/** @internal */
export type GetDomainRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetDomainRequest$outboundSchema: z.ZodMiniType<
  GetDomainRequest$Outbound,
  GetDomainRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getDomainRequestToJSON(
  getDomainRequest: GetDomainRequest,
): string {
  return JSON.stringify(
    GetDomainRequest$outboundSchema.parse(getDomainRequest),
  );
}
